<script>
import methods from '../../mixins/methods'

export default {
  name: 'MetaTags',
  mixins: [
    methods
  ],
  render () {
    return null
  },
  data () {
    return {
      uuid: this.$uuidv4(),
      dataAttr: 'data-bcq-uuid'
    }
  },
  props: {
    items: {
      type: Array,
      default () {
        return []
      }
    },
    documentTitle: {
      type: String
    },
    disposeMetaTagsBeforeDestroy: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    items () {
      this.init()
    },
    documentTitle () {
      this.setTitle()
    }
  },
  beforeDestroy () {
    this.dispose()
  },
  methods: {
    head () {
      return document.querySelector('head')
    },
    dispose () {
      if (this.disposeMetaTagsBeforeDestroy) {
        this.head().querySelectorAll(`[${this.dataAttr}="${this.uuid}"]`).forEach(meta => {
          meta.remove()
        })
      }
      this.$emit('before-destroy')
    },
    setTitle () {
      document.title = this.documentTitle
    },
    exists (id) {
      return document.getElementById(id)
    },
    init () {
      const head = this.head()
      this.items.forEach((item, index) => {
        const type = item.type.toLowerCase()
        const id = `bcq-meta-tags-${type}-${index}`
        const exists = this.exists(id)
        const tag = exists || document.createElement(type)
        const load = item['@load']
        const uuid = `${this.uuid}`
        if (!item.attrs.id) {
          item.attrs.id = id
        }
        Object.keys(item.attrs).forEach(attr => {
          const value = item.attrs[attr]
          if (['innerHTML'].includes(attr) && type === 'script') {
            if (item.attrs.type === 'application/ld+json') {
              tag.innerHTML = JSON.stringify(value)
            }
          } else {
            tag.setAttribute(attr, typeof value === 'object' && value.length ? value.join(', ') : value)
          }
        })
        if (type === 'script' && load) {
          tag.addEventListener('load', () => {
            this.$emit(load)
          })
        }
        tag.setAttribute(this.dataAttr, uuid)
        if (!exists) {
          head.appendChild(tag)
        }
      })
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/meta-tags/meta-tags.vue